/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive, HostListener} from '@angular/core';

import {IfOpenService} from '../../utils/conditional/if-open.service';

import {Dropdown} from './dropdown';
export class DropdownTrigger {
private isRootLevelToggle: boolean = true;
/**
 * @param {?} dropdown
 * @param {?} ifOpenService
 */
constructor(private dropdown: Dropdown,
private ifOpenService: IfOpenService) {
        // if the containing dropdown has a parent, then this is not the root level one
        if (dropdown.parent) {
            this.isRootLevelToggle = false;
        }
    }
/**
 * @return {?}
 */
get active(): boolean {
        return this.ifOpenService.open;
    }
/**
 * @param {?} event
 * @return {?}
 */
onDropdownTriggerClick(event: any): void {
        this.ifOpenService.toggleWithEvent(event);
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    // We support both selectors for legacy reasons
    selector: "[clrDropdownTrigger],[clrDropdownToggle]",
    host: {
        "[class.dropdown-toggle]": "isRootLevelToggle",
        "[class.dropdown-item]": "!isRootLevelToggle",
        "[class.expandable]": "!isRootLevelToggle",
        "[class.active]": "active"
    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Dropdown, },
{type: IfOpenService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onDropdownTriggerClick': [{ type: HostListener, args: ["click", ["$event"], ] },],
};
}

function DropdownTrigger_tsickle_Closure_declarations() {
/** @type {?} */
DropdownTrigger.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DropdownTrigger.ctorParameters;
/** @type {?} */
DropdownTrigger.propDecorators;
/** @type {?} */
DropdownTrigger.prototype.isRootLevelToggle;
/** @type {?} */
DropdownTrigger.prototype.dropdown;
/** @type {?} */
DropdownTrigger.prototype.ifOpenService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
